module.exports = __webpack_public_path__ + "img/logo@2x.f67b148a.png";